
import HubWebinar from "@/models/hub/HubWebinar"
import { defineComponent, PropType } from "vue"
import VideoPanel from "./VideoPanel.vue"
export default defineComponent({
  components: { VideoPanel },
  props: {
    webinars: { type: Object as PropType<Array<HubWebinar>>, required: true }
  },
  setup() {
    const NO_OF_PRELOADS = 10
    return { NO_OF_PRELOADS }
  }
})
